import Layout from "@/components/feature/Layout";

const email = "info@rakuraku-digital-navi.com";

export default function Contact() {
  return (
    <Layout>
      <section className="border-b border-background-300 bg-background-200">
        <div className="mx-auto max-w-[900px] px-4 md:px-6 py-10 md:py-14">
          <div className="text-xs text-secondary-600 font-semibold tracking-widest">お問い合わせ</div>
          <h1 className="mt-2 text-2xl md:text-3xl font-bold text-foreground-900">掲載内容について、お知らせください</h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7">料金・条件・リンクの誤りや、サイトについてのご質問をメールで受け付けています。</p>
        </div>
      </section>

      <section className="mx-auto max-w-[900px] px-4 md:px-6 py-12 space-y-8 text-[15px] text-foreground-700 leading-8">
        <div className="rounded-xl border border-background-300 bg-background-50 p-6 md:p-8">
          <div className="flex items-start gap-4">
            <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 text-xl"><i className="ri-mail-line" /></span>
            <div>
              <h2 className="text-xl font-bold text-foreground-900">メールでのお問い合わせ</h2>
              <a href={`mailto:${email}?subject=${encodeURIComponent("スマホ代見直し案内所へのお問い合わせ")}`} className="mt-3 inline-block text-primary-500 font-semibold underline break-all">{email}</a>
              <p className="mt-3 text-sm">メールアプリが開かない場合は、上記アドレスをコピーしてお送りください。掲載内容については、該当ページのURLと気になった箇所を添えていただくと確認しやすくなります。</p>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">お問い合わせの前に</h2>
          <ul className="mt-4 space-y-2">
            <li className="flex gap-2"><i className="ri-check-line text-secondary-500 mt-1.5" />掲載情報の修正依頼には、対象ページと根拠となる公式ページがあればお知らせください。</li>
            <li className="flex gap-2"><i className="ri-check-line text-secondary-500 mt-1.5" />契約内容、請求、解約、回線トラブルは、ご契約中の通信会社へお問い合わせください。</li>
            <li className="flex gap-2"><i className="ri-check-line text-secondary-500 mt-1.5" />当サイトから契約情報の確認、申し込み、解約などを代行することはできません。</li>
          </ul>
        </div>

        <div className="rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-6">
          <div className="flex items-start gap-3"><i className="ri-alert-line text-accent-600 text-xl mt-1" /><div><h2 className="font-bold text-foreground-900">重要な情報を送らないでください</h2><p className="mt-2 text-sm">パスワード、暗証番号、認証コード、クレジットカード番号、本人確認書類、契約書や請求書の画像などは送信しないでください。</p></div></div>
        </div>
      </section>
    </Layout>
  );
}
